import Enum from "@/enums/Enum";
import BaseEnum from "@/enums/BaseEnum";
/**
 * 歯石沈着度
 */
export default class ShisekiChinchakudo extends BaseEnum{
    static NASHI = {value: '0', name: 'ありません'} as Enum
    static SUKUNAI = {value: '1', name: '少ない'} as Enum
    static HUTSU = {value: '2', name: '普通'} as Enum
    static OOI = {value: '3', name: '多い'} as Enum
}
ShisekiChinchakudo.values = [ShisekiChinchakudo.NASHI, ShisekiChinchakudo.SUKUNAI, ShisekiChinchakudo.HUTSU, ShisekiChinchakudo.OOI]
